import { ChartOption, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const series = [];

  const seriesData: Array<any> = [];
  for (let j = 0; j < datas.rowCount; j++) {
    if (datas.rowDimNodes[j][0].total) {
      continue;
    }

    let count = 0;
    if (datas.dataValues[datas.rowColIndexes[j][0]]) {
      count = datas.dataValues[datas.rowColIndexes[j][0]][0];
    }

    seriesData.push({
      name: datas.rowDimNodes[j][0].label,
      value: count,
    });
  }

  let seriesLabel: any = {};
  if (!chartOption.hideLabel) {
    seriesLabel = {
      formatter: "{b}({c})",
    };
  }

  series.push({
    name: definition.measures[0].label,
    type: "pie",
    radius: "55%",
    center: ["40%", "50%"],
    label: seriesLabel,
    data: seriesData,
  });

  const option: any = {
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    grid: {
      // top: '24%',
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    series: series,
  };

  if (!chartOption.hideLegend) {
    const legendData: Array<string> = [];
    for (let i = 0; i < datas.rowDimNodes.length; i++) {
      if (datas.rowDimNodes[i][0].total) {
        continue;
      }
      legendData.push(datas.rowDimNodes[i][0].label);
    }

    option.legend = {
      orient: "vertical",
      left: "left",
      x: "32%",
      y: "32%",
    };
  }

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title,
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.toolbox = {
      show: true,
      feature: {
        saveAsImage: {},
      },
    };
  }

  return option;
}
